import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { ValidMe } from '../../../../businessLogic/validation.js';

export default function CenterPanelUpdate(props) {
  return (
    <div className="ui form mrbl">
      <div className="bold title-sms">{APP.LANGUAGE.OrgUnitSupportContact.SupportInfoForProviders}</div>
      <div className="mrbm mrtm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitSupportContact.SupportNameView}</div>
        <div className="title-sms">
          {props.updatedOrgUnitSupportContactForm.organisaionSupportName ||
            APP.LANGUAGE.OrgUnitSupportContact.NotProvided}
        </div>
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitSupportContact.SupportEmailView}</div>
        {!!props.updatedOrgUnitSupportContactForm.organisaionSupportEmail &&
        props.updatedOrgUnitSupportContactForm.organisaionSupportEmail !==
          APP.LANGUAGE.OrgUnitSupportContact.NotProvided ? (
          <a
            target="support-contact"
            onClick={() => {
              window.location.href = 'mailto:' + props.updatedOrgUnitSupportContactForm.organisaionSupportEmail;
            }}
          >
            {props.updatedOrgUnitSupportContactForm.organisaionSupportEmail}
          </a>
        ) : (
          <div className="title-sms">{APP.LANGUAGE.OrgUnitSupportContact.NotProvided}</div>
        )}
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.OrgUnitSupportContact.SupportTelView}</div>
        <div className="title-sms">
          {props.updatedOrgUnitSupportContactForm.organisaionSupportPhone ||
            APP.LANGUAGE.OrgUnitSupportContact.NotProvided}
        </div>
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">
          {APP.LANGUAGE.OrgUnitSupportContact.SupportWebsiteView}
        </div>
        {!!props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite &&
        props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite !== 'Not available' &&
        props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite !==
          APP.LANGUAGE.OrgUnitSupportContact.NotProvided ? (
          <a
            className="mrbm"
            target="support-contact"
            href={props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite}
          >
            {props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite}
          </a>
        ) : (
          <div className="title-sms mrbxl">{APP.LANGUAGE.OrgUnitSupportContact.NotProvided}</div>
        )}
      </div>
      <div className="mrtm">
        <div className="bold title-sms mrtm">{APP.LANGUAGE.OrgUnitSupportContact.SupportInfoForCallers}</div>
        <div className="placeholder-label color-placeholder mrtm">
          {APP.LANGUAGE.OrgUnitSupportContact.MoreAssistInfo}
        </div>
        <div className="sixteen wide column mrbm div-as-textArea-wrapper">
          <textarea
            className="div-as-textArea read-only"
            style={{ maxHeight: '136px' }}
            readOnly
            defaultValue={
              props.updatedOrgUnitSupportContactForm.moreAssistance || APP.LANGUAGE.OrgUnitSupportContact.NotProvided
            }
          />
        </div>
      </div>
    </div>
  );
}
